import { CloseButton, Combobox } from '@mantine/core';

type SiteSelectRightSectionPropsType = {
  ariaLabel: string;
  onClear: () => void;
  showClear: boolean;
};

export const SiteSelectRightSection: React.FC<
  SiteSelectRightSectionPropsType
> = ({ ariaLabel, onClear, showClear }) => {
  if (!showClear) {
    return <Combobox.Chevron />;
  }

  return (
    <CloseButton
      aria-label={ariaLabel}
      onClick={(event) => {
        event.stopPropagation();
        onClear();
      }}
      onMouseDown={(event) => {
        event.preventDefault();
      }}
      size="sm"
    />
  );
};
